import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-24340d69")

_pushScopeId("data-v-24340d69")
const _hoisted_1 = { class: "button-frame" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("カルテ追加")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("問診追加")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_list_title = _resolveComponent("list-title")
  const _component_list_row = _resolveComponent("list-row")
  const _component_vue_y_scroll_area = _resolveComponent("vue-y-scroll-area")
  const _component_karte_template_modal = _resolveComponent("karte-template-modal")
  const _component_inquiry_model = _resolveComponent("inquiry-model")
  const _component_vue_content = _resolveComponent("vue-content")

  return (_openBlock(), _createBlock(_component_vue_content, null, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_normal_button, {
          class: "vue-head-button-frame-button",
          state: "normal",
          disabled: !_ctx.patientWrite,
          onClick: _ctx.onAddKarte
        }, {
          default: _withId(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_normal_button, {
          class: "vue-head-button-frame-button",
          state: "normal",
          disabled: !_ctx.patientWrite,
          onClick: _ctx.onAddInquiry
        }, {
          default: _withId(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      _createVNode(_component_list_title, { titles: _ctx.consultationTitles }, null, 8, ["titles"]),
      _createVNode(_component_vue_y_scroll_area, { onTop: _ctx.onFetchOld }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.consultationRows, (row) => {
            return (_openBlock(), _createBlock(_component_list_row, {
              key: row.id,
              rowId: row.id,
              columns: row.columns,
              class: "consultation-list-row",
              onBookmark: _ctx.onBookmark,
              onUp: _ctx.onUp,
              onDown: _ctx.onDown
            }, null, 8, ["rowId", "columns", "onBookmark", "onUp", "onDown"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["onTop"]),
      _createVNode(_component_karte_template_modal, {
        ref: "karteTemplateRef",
        onYes: _ctx.yseTemplate
      }, null, 8, ["onYes"]),
      _createVNode(_component_inquiry_model, {
        ref: "inquiryRef",
        onYes: _ctx.yesInquiry
      }, null, 8, ["onYes"])
    ]),
    _: 1
  }))
})